module.exports = __webpack_public_path__ + "static/media/ayb.95ec8cb6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ayb.webp
// module id = 613
// module chunks = 0